export default Object.freeze({
  STATE: {
    BUSY: 'busy',
    IDLE: 'idle',
    ERROR: 'error',
  },
});
